import Vue from 'vue'
import App from './App.vue'
import Router from './router';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import {faCamera} from '@fortawesome/free-solid-svg-icons'
import {faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSignaturePad from 'vue-signature-pad';
import vClickOutside from 'v-click-outside'
import VueStripeCheckout from 'vue-stripe-checkout';
import VModal from 'vue-js-modal';
 
Vue.use(VModal);
Vue.use(VueStripeCheckout, 'pk_test_EecZldy3jZ9fElTkG5I642pM');
Vue.use(vClickOutside); 
Vue.use(VueSignaturePad);

Vue.config.productionTip = false

library.add(faAngleUp)
library.add(faChevronRight)
library.add(faAngleDown)
library.add(faArrowAltCircleLeft)
library.add(faPlus)
library.add(faCamera)
Vue.component('font-awesome-icon', FontAwesomeIcon)

var hostname = new URL(window.location.href).hostname;

if(hostname.indexOf('second-oeuvre')>-1){
  if (location.protocol != 'https:'){
    location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
  }
}

if('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('/service-worker.js')
		.then(function() { console.log("Service Worker Registered"); });
}

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

new Vue({
  router: Router,
  render: h => h(App),
}).$mount('#app')
